import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { PrestoLinkedService } from 'app/model/linkedservice/presto.linkedservice';
import { Metamodel } from 'app/model/base/model';
import { PrestoObjectDataset } from 'app/model/dataset/presto.dataset';
import { ColumnType, defaultSupportedColumnTypes } from 'app/shared/utils/column-type.util';
import { compact } from 'lodash';
import { format } from 'app/shared/utils/string.util';

export const prestoObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(PrestoObjectDataset).name,
    displayName: stringResources.Presto_DisplayText,
    supportLinkedServiceTypes: [Metamodel.modelFor(PrestoLinkedService).name],
    showWarningMessage: '{ linkedService && linkedService.version !== "v2" }',
    warningMessage: format(
        stringResources.Dataset_Legacy_IsNotSupportedWarning_alt3,
        stringResources.VersionLabel.toLocaleLowerCase()
    ),
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-presto'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    splitTablePath: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    supportDataTypes: defaultSupportedColumnTypes.concat(compact([ColumnType.SByte, ColumnType.Date, ColumnType.Time])),
    category: ['Database']
};
